import React from 'react'
import { browserHistory } from 'react-router';

const EventModalButton = ({text,route}) => {
  const navigate =() =>{
    browserHistory.push(route)
  }
  return (
    <button className='evnt_btn_primary' onClick={navigate}>{text}</button>
  )
}

export default EventModalButton